
import D from '../images/dashh.svg'

import Gauge from '../Components/MyGauge'
import S from './Dashboard.module.css'
import StChart from '../Components/StockChart';
import {  useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';


import StChart2 from '../Components/StockChart2';
import WarningStatus from '../Components/WarningStatus';
import { useGlobalContext } from '../Components/Context';

import apiService from '../api/ApiService';
import { addCycle, addPenStatus, addStatus } from '../redux/slices/PensStatusSlice';
import { addDetailStatusList, setStatusCount } from '../redux/slices/adminSlice';




const Dashboard=()=>{
  const {isStatusOpen}=useGlobalContext()

  const {currentAdmin,statusCount}=useSelector(state=>state.p.admin);
  const {currentTimeDiff,duration,offSet}=useSelector(state=>state.p.time)
    const [data,setData]=useState([])
    const [tempHum,setTempHum]=useState({temp:0,hum:0})
    const dispatch=useDispatch()
    const [dataPI,setDataPI]=useState({count:[],status:[]})
    const getDataPii=async()=>{
        const dat=JSON.stringify({
            "penIds": [],
            "includePen": true,
            "date": currentTimeDiff,
          })
        const res=await apiService.getFatmsStatus(dat)
  
        setTempHum({temp:res.data?.lastTemperature,hum:res.data?.lastHumidity})
        const filter=res.data.pens.map((item=>{
            const {totalCattles,penName}=item
            return {value:totalCattles,name:penName.substring(7)}
        }));
        const filter2=res.data.statuses.map(item=>{
            const {title,count}=item;
            return {value:count,name:title}
        })
        const filter4=res.data.lifeCycles.map(item=>{
          const {title,count}=item;
          return {value:count,name:title}
      })
        const filter3=[{value:res.data.totalCattleWithSensors,name:'  با گردنبند'},{value:res.data.totalCattleWithOutSensors,name:'  بدون گردنبند '}]
        setDataPI({status:filter2,count:filter,all:res.data.totalCattles,withSens:filter3})
        setDataPI({status:filter2,count:filter,all:res.data.totalCattles,withSens:filter3,cycle:filter4})
    }

    const getData=async()=>{

        const data=JSON.stringify({
          "penIds": [],
          "offSet":offSet,
          "date": currentTimeDiff,
          "durationDay": duration
        })
        const res=await apiService.getDashboardStats(data)
        dispatch(setStatusCount(res.data?.totalCattleStatusChangeCount24Hours))
        setData(res.data);
    }
    const gett=async()=>{
      const res3=await apiService.getDetailsCattleStatus()
      dispatch(addDetailStatusList(res3.data?.data))
    }
    useEffect(()=>{
       getData()
       getDataPii();gett();    },[]);
    


    return <><div className={S.DashboardCon}>
        <div className={S.DashboardTitleCon} >
        <img className={S.SidebarIconimgTit} src={D}/>
        <h2 >داشبورد</h2>
        </div>
        <hr/>
        
    <div  style={{direction:'ltr'}}>
    <Gauge averageStat={data&&data.averageStat} day30={data&&data?.cattle30DaysStats} chart={data&&data.cattle24HoursStat} hour8={data&&data?.cattleEvery8HoursStats} hours720={data&&data?.cattle720HoursStats} dataPI={dataPI} tempHum={tempHum} label={'گله'}/>
     
      </div>     </div>
      {isStatusOpen&&statusCount&&<WarningStatus/>}
    </>
}
export default Dashboard